var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSvhTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 143,
    viewBox: "0 0 272 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_5121)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 10C32.1635 10 25 17.1634 25 26V39.6967L10.3033 54.0044C9.78043 54.5134 10.1472 55.1877 10.9842 55.256L25 56.3997V117C25 125.837 32.1635 133 41 133H246C254.837 133 262 125.837 262 117V26C262 17.1634 254.837 10 246 10H41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 39.6967L26.0463 40.7715L26.5 40.3299V39.6967H25ZM10.3033 54.0044L9.25701 52.9296H9.25701L10.3033 54.0044ZM10.9842 55.256L11.1062 53.761H11.1062L10.9842 55.256ZM25 56.3997H26.5V55.0171L25.122 54.9047L25 56.3997ZM26.5 26C26.5 17.9919 32.9919 11.5 41 11.5V8.5C31.335 8.5 23.5 16.335 23.5 26H26.5ZM26.5 39.6967V26H23.5V39.6967H26.5ZM11.3497 55.0791L26.0463 40.7715L23.9537 38.622L9.25701 52.9296L11.3497 55.0791ZM11.1062 53.761C11.0346 53.7551 11.2738 53.752 11.4515 54.0787C11.5448 54.2502 11.5867 54.468 11.5446 54.6877C11.5036 54.9012 11.4013 55.0289 11.3497 55.0791L9.25701 52.9296C8.58628 53.5825 8.31812 54.5967 8.81617 55.5123C9.25579 56.3204 10.0969 56.6886 10.8622 56.751L11.1062 53.761ZM25.122 54.9047L11.1062 53.761L10.8622 56.751L24.878 57.8947L25.122 54.9047ZM26.5 117V56.3997H23.5V117H26.5ZM41 131.5C32.9919 131.5 26.5 125.008 26.5 117H23.5C23.5 126.665 31.335 134.5 41 134.5V131.5ZM246 131.5H41V134.5H246V131.5ZM260.5 117C260.5 125.008 254.008 131.5 246 131.5V134.5C255.665 134.5 263.5 126.665 263.5 117H260.5ZM260.5 26V117H263.5V26H260.5ZM246 11.5C254.008 11.5 260.5 17.9919 260.5 26H263.5C263.5 16.335 255.665 8.5 246 8.5V11.5ZM41 11.5H246V8.5H41V11.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_5121",
    x: 0.559143,
    y: 0.5,
    width: 270.941,
    height: 142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.365319 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_5121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_5121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvhTwo);
export default __webpack_public_path__ + "static/media/message_svh_two.782d789b82ea394724cd8422455838d4.svg";
export { ForwardRef as ReactComponent };